module.exports = __webpack_public_path__ + "static/media/videoImg.4cb76b64.jpg";